import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PotentialPromotionsComponent } from './potential-promotions.component';

@NgModule({
  exports: [PotentialPromotionsComponent],
  imports: [CommonModule, MatIconModule, PotentialPromotionsComponent],
})
export class PotentialPromotionsModule {}
